import Dashboard from "@base/Dashboard/Dashboard";

export default Dashboard;
